<template>
  <div class="smartkeyAuth getKey notranslate">
    <div class="title mb30">
      <h2>{{locale.smartkey}}</h2>
      <p v-if="getStatus === 200">{{openMessage()}}</p>
    </div>
    <div class="formGroup mb30">
      <div class="input">
        <GetKey @setStatus="setStatus" />
      </div>
    </div>
    <div v-if="useRemoteOpen">
      <p class="colorGrey mb10">{{ locale.smartkey_view_remotekey_title }}</p>
      <Remotekey class="remotekey" />
    </div>
  </div>
</template>

<script>
import GetKey from './GetKey'
import Remotekey from './RemoteKey'

export default {
  props: [
    'ln',
    'locale',
    'isPublic',
    'space', // 스마트키가 있는 공간
    'keyOtaId' // 스마트키 호출을 위한 유니크id로 이 키와 매핑된 spaceid(객실, 라커 등)로 인증
  ],
  components: {
    GetKey,
    Remotekey
  },
  computed: {
    getStatus () {
      return this.status
    },
    mobilekeyInfo () {
      return this.$store.getters['guest/getMobilekeyInfo']
    },
    useRemoteOpen () {
      return this.$store.getters['guest/getUseRemotekey']
    },
  },
  data () {
    return {
      status: null
    }
  },
  methods: {
    setStatus (status) {
      this.status = status
    },
    openMessage () {
      const spaceCodeType = (this.mobilekeyInfo && this.mobilekeyInfo.spaceCodeType) || 'R'
      return this.locale[`smartkey_view_title_${spaceCodeType}`]
    }
  }
}
</script>
